<template>
	<span></span>
</template>

<script>
import banner from '@/assets/images/banner.png'

export default {
	props: {
		post: {
			type: Object,
			default: () => {},
		},
		background: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			banner,
		}
	},
	methods: {
		navigateToPost() {
			this.$router.push({ name: 'featured-post', params: { id: this.post.id } })
		},
	},
}
</script>

<style scoped lang="scss">
.featured-post-card {
	position: relative;
	max-height: 400px;
	overflow: hidden;
	max-width: 600px;

	&__bg-image {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: auto;
		-o-object-fit: cover;
		object-fit: cover;
	}

	&__bg-image:after {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		background: rgba(0, 0, 0, 0.5);
	}

	&__title {
		position: relative;
		font-family: Arial;
		font-style: normal;
		font-weight: bold;
		font-size: 30px;
		line-height: 36px;
		color: #fff;
	}

	&__content {
		position: relative;
		font-family: Montserrat;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 20px;
		color: #ffffff;
	}

	&__cta:hover {
		background-color: var(--accent-color) !important;
	}

	&__cta {
		border-radius: 54.5px;
		text-transform: none;
		color: #fff !important;
		font-family: Calibri !important;
		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		line-height: 16px;
		text-align: center;

		.theme--light.v-btn:hover::before {
			opacity: 0 !important;
		}
	}

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}

@media screen and (max-width: 500px) {
	.featured-post-card {
		&__bg-image {
			height: 100%;
		}
	}
}
@media screen and (max-width: 1264px) {
	.featured-post-card {
		max-width: none;
		width: 100%;
	}
}

@media screen and (max-width: 320px) {
	.featured-post-card {
		&__title {
			padding-top: 0;
		}
		&__content {
			padding-bottom: 0 !important;
		}
	}
}
</style>
